import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";

import { IRequestFailed } from "@app/types";
import { IAssignCustomerPayload, ISalesPersonState } from "./types";

const initialState: ISalesPersonState = {
  salesPerson: {},
  addSalesPerson: {},
  updateSalesPerson: {},
  deleteSalesPerson: {},
  assignCustomerToSalesPerson: {},
  customer: {},
  salesPersonDetails: {},
  deleteAssignCustomers: {},
};

const slice = createSlice({
  name: "model",
  initialState,
  reducers: {
    salesPerson(state, action: PayloadAction<{ role: string }>) {
      state.salesPerson.status = RequestStatus.RUNNING;
    },
    salesPersonSuccess(state, action) {
      state.salesPerson.status = RequestStatus.SUCCESS;
      state.salesPerson.data = action.payload;
    },
    salesPersonFailed(state, action: PayloadAction<any>) {
      state.salesPerson.status = RequestStatus.ERROR;
      state.salesPerson.error = action.payload;
    },
    customer(state, action: PayloadAction<any>) {
      state.customer.status = RequestStatus.RUNNING;
    },
    customerSuccess(state, action) {
      state.customer.status = RequestStatus.SUCCESS;
      state.customer.data = action.payload;
    },
    customerFailed(state, action: PayloadAction<any>) {
      state.customer.status = RequestStatus.ERROR;
      state.customer.error = action.payload;
    },
    addSalesPerson(state, action: PayloadAction<any>) {
      state.addSalesPerson.status = RequestStatus.RUNNING;
    },
    addSalesPersonSuccess(state, action) {
      state.addSalesPerson.status = RequestStatus.SUCCESS;
      state.addSalesPerson.data = action.payload;
    },
    addSalesPersonFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addSalesPerson.status = RequestStatus.ERROR;
      state.addSalesPerson.error = action.payload;
    },
    updateSalesPerson(state, action: PayloadAction<any>) {
      state.updateSalesPerson.status = RequestStatus.RUNNING;
    },
    updateSalesPersonSuccess(state, action) {
      state.updateSalesPerson.status = RequestStatus.SUCCESS;
      state.updateSalesPerson.data = action.payload;
    },
    updateSalesPersonFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateSalesPerson.status = RequestStatus.ERROR;
      state.updateSalesPerson.error = action.payload;
    },
    deleteSalesPerson(state, action: PayloadAction<{ salesPersonId: number }>) {
      state.deleteSalesPerson.status = RequestStatus.RUNNING;
    },
    deleteSalesPersonSuccess(state, action) {
      state.deleteSalesPerson.status = RequestStatus.SUCCESS;
      state.deleteSalesPerson.data = action.payload;
    },
    deleteSalesPersonFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteSalesPerson.status = RequestStatus.ERROR;
      state.deleteSalesPerson.error = action.payload;
    },
    assignCustomerToSalesPerson(
      state,
      action: PayloadAction<IAssignCustomerPayload>
    ) {
      state.assignCustomerToSalesPerson.status = RequestStatus.RUNNING;
    },
    assignCustomerToSalesPersonSuccess(state, action) {
      state.assignCustomerToSalesPerson.status = RequestStatus.SUCCESS;
      state.assignCustomerToSalesPerson.data = action.payload;
    },
    assignCustomerToSalesPersonFailed(
      state,
      action: PayloadAction<IRequestFailed>
    ) {
      state.assignCustomerToSalesPerson.status = RequestStatus.ERROR;
      state.assignCustomerToSalesPerson.error = action.payload;
    },
    salesPersonDetails(
      state,
      action: PayloadAction<{ id: number }>
    ) {
      state.salesPersonDetails.status = RequestStatus.RUNNING;
    },
    salesPersonDetailsSuccess(state, action) {
      state.salesPersonDetails.status = RequestStatus.SUCCESS;
      state.salesPersonDetails.data = action.payload;
    },
    salesPersonDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.salesPersonDetails.status = RequestStatus.ERROR;
      state.salesPersonDetails.error = action.payload;
    },
    //
    deleteAssignCustomers(
      state,
      action: PayloadAction<{ customerId: number; userId: number }>
    ) {
      state.deleteAssignCustomers.status = RequestStatus.RUNNING;
    },
    deleteAssignCustomersSuccess(state, action) {
      state.deleteAssignCustomers.status = RequestStatus.SUCCESS;
      state.deleteAssignCustomers.data = action.payload;
    },
    deleteAssignCustomersFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteAssignCustomers.status = RequestStatus.ERROR;
      state.deleteAssignCustomers.error = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  salesPerson,
  salesPersonSuccess,
  salesPersonFailed,
  customer,
  customerSuccess,
  customerFailed,
  addSalesPerson,
  addSalesPersonSuccess,
  addSalesPersonFailed,
  updateSalesPerson,
  updateSalesPersonSuccess,
  updateSalesPersonFailed,
  deleteSalesPerson,
  deleteSalesPersonSuccess,
  deleteSalesPersonFailed,
  assignCustomerToSalesPerson,
  assignCustomerToSalesPersonSuccess,
  assignCustomerToSalesPersonFailed,
  salesPersonDetails,
  salesPersonDetailsSuccess,
  salesPersonDetailsFailed,
  deleteAssignCustomers,
  deleteAssignCustomersFailed,
  deleteAssignCustomersSuccess,
} = slice.actions;
